// extracted by mini-css-extract-plugin
export default {"CircularIconContainer":"Icons_CircularIconContainer__yfNIi"};